import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import i18next from 'i18next';

declare var bootstrap: any;

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
  standalone: false
})
export class PopoverComponent {
  @Input() thesaurusId: string = "";
  @ViewChild('popoverTrigger', { static: true }) popoverTrigger!: ElementRef;
  screenReaderDescr: string = "";
  popoverData: { [key: string]: { title: string, content: string, description: string } } = {
    "acta_lexicon_qualifiers": {
      title: i18next.t("lexiconLinkLabel"),
      content: i18next.t("lexiconDescription"),
      description: i18next.t("lexiconLinkLabel")
    },
    "company": {
      title: i18next.t("company_infoIcon_title"),
      content: i18next.t("company_infoIcon_content"),
      description: i18next.t("company_infoIcon_title")
    }
  };

  constructor(
    private cdr: ChangeDetectorRef
  ) { }

  ngAfterViewInit(): void {
    this.createPopover(this.thesaurusId);
    this.setScreenReaderDescription(this.thesaurusId);
    this.cdr.detectChanges();
  }

  createPopover(id: string): any {
    const popover = new bootstrap.Popover(this.popoverTrigger.nativeElement, {
      title: this.getPopoverTitle(this.thesaurusId),
      content: this.getPopoverContent(this.thesaurusId),
      html: true,
      trigger: 'manual',
      container: '.popover-container',
      template: '<div class="popover p-0" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    });
    
    const element = this.popoverTrigger.nativeElement;
    const popoverContentId = document.querySelector(".thesaurus-title .popover-body");

    //Toggle popover when user clicks repeatedly clicks (or presses the enter key) on the info icon
    element.addEventListener('click', (event: Event) => this.togglePopover(event, popover));
    element.addEventListener('keydown', (event: Event) => this.togglePopover(event, popover));
    element.setAttribute('aria-describedby', popoverContentId);

    //Toggle popover when user clicks away from the popover 
    document.addEventListener('click', (event) => {
      if (!this.popoverTrigger.nativeElement.contains(event.target)) {
        popover.hide();
      }
    });
  }

  getPopoverData(id: string): { title: string, content: string, description: string } {
    for (const key in this.popoverData) {
      if (id.includes(key)) {
        return this.popoverData[key];
      }
    }

    return { title: "", content: "", description: "" };
  }

  getPopoverTitle(id: string): string {
    return this.getPopoverData(id).title;
  }

  getPopoverContent(id: string): string {
    return this.getPopoverData(id).content;
  }

  setScreenReaderDescription(id: string): void {
    this.screenReaderDescr = this.getPopoverData(id).description;
  }

  togglePopover(event: Event, popover: any): void {
    if (event.type === 'click' || (event instanceof KeyboardEvent && event.key === 'Enter')) {
      if (popover._isShown()) {
        popover.hide();
      } else {
        popover.show();
      }
    }
  }

}
